module.exports = __webpack_public_path__ + "static/media/bannerL.e5cf2901.png";